/* Hand-curated set of classic palindromes drawn from
   `unoriginal-palindromes.yaml`. Each hint follows the rules in
   `palindromist.md §"Hint + keywords"`: ≤ 60 chars, no literal words
   shared with the answer, no obvious thesaurus swaps — sideways framing,
   metonymy, or scene detail that becomes obvious only in retrospect. */

import type { Puzzle } from "./puzzle";

const DEFAULT_GUESSES = 8;

const make = (
  id: number,
  sentence: string,
  hint: string,
  difficulty: 1 | 2 | 3 | 4 | 5 = 2,
): Puzzle => ({
  id,
  date: "2026-04-26",
  sentence,
  hint: hint,
  difficulty,
  maxGuesses: DEFAULT_GUESSES,
});

export const PUZZLES: readonly Puzzle[] = [
  make(1, "A man, a plan, a canal, Panama!", "Maybe in Teddy's honor.", 2),
  make(2, "Madam, I'm Adam.", "Eden's first introduction.", 1),
  make(3, "Was it a car or a cat I saw?", "Sleepy roadside double-take.", 3),
  make(4, "No lemon, no melon.", "A complaint at the empty produce stand.", 1),
  make(5, "Never odd or even.", "Mathematician's oxymoron.", 1),
  make(6, "Step on no pets.", "Veterinarian's house rule.", 1),
  make(7, "Do geese see God?", "Honking philosophers.", 2),
  make(8, "Mr. Owl ate my metal worm.", "Hooked bait gone in the night.", 3),
  make(9, "A Santa at NASA.", "Yuletide visit to the launch pad.", 2),
  make(10, "Now, sir, a war is won!", "Battlefield telegram with welcome news.", 2),
  make(11, "Race fast, safe car.", "An ad copywriter's paradox.", 2),
  make(12, "Able was I ere I saw Elba.", "An emperor's island lament.", 3),
  make(13, "Rise to vote, sir.", "Civic call from a courteous host.", 2),
  make(14, "I prefer pi.", "A mathematician's dessert order.", 1),
  make(15, "Senile felines.", "Whiskers losing the plot.", 1),
];

export function pickRandomPuzzle(): Puzzle {
  const i = Math.floor(Math.random() * PUZZLES.length);
  return PUZZLES[i]!;
}
